// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607281733/js/" + chunkId + "." + {"44":"22e7c15b","225":"f600cfc1","481":"28bcd45c","486":"3d237bb2","770":"cd2de09f"}[chunkId] + ".0.9792022436239113.chunk.js";
};